import React from 'react';
import { ListItemProps } from '../OptionsList/OptionsList';
import { SelectBoxOption } from '../../SelectBox.types.';
import Image from '../../../../Image/Image';
import Skeleton from '../../../../Skeleton/Skeleton';
import styles from './Option.module.css';
import cn from 'classnames';

export type OptionProps<T extends SelectBoxOption> = ListItemProps<T> & {
    isActive?: boolean;
    onClick?: (item: T | undefined, e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    renderRight?: (props: ListItemProps<T>) => React.ReactNode;
    disabled?: boolean;
};

const Option = <T extends SelectBoxOption>({
    item,
    loading,
    style,
    isActive,
    onClick,
    renderRight,
    disabled,
}: OptionProps<T>) => {
    const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (typeof onClick === 'function') {
            onClick(item, e);
        }
    };

    return (
        <div
            style={style}
            className={cn(styles.listItem, { [styles.active]: isActive, [styles.disabled]: disabled })}
            onClick={handleClick}
        >
            <Image src={item?.picture} loading={loading} alt="" className={styles.itemImage} />
            <div className={styles.itemContent}>
                <p className={styles.label}>{loading ? <Skeleton /> : item?.name}</p>
                <p className={styles.subtitle}>{loading ? <Skeleton /> : item?.subtitle}</p>
            </div>
            {typeof renderRight === 'function' && renderRight({ item, loading, style })}
        </div>
    );
};

export default Option;
